import { FunctionalComponent, h } from 'preact';

export const ReloadIcon: FunctionalComponent<{fill?: string}> = (props) => {
	const {fill = '#6E37D8'} = props;

	return (
		<svg width="16" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.375 4.25h-.313a.375.375 0 00-.374.375v3.457A7.746 7.746 0 007.974 4.25C3.713 4.263.243 7.75.25 12.012a7.75 7.75 0 0012.943 5.74.376.376 0 00.015-.544l-.22-.22a.374.374 0 00-.516-.015A6.661 6.661 0 018 18.688 6.687 6.687 0 011.313 12a6.687 6.687 0 0112.633-3.062h-3.571a.375.375 0 00-.375.375v.312c0 .207.168.375.375.375h5a.375.375 0 00.375-.375v-5a.375.375 0 00-.375-.375z"
				fill={fill}/>
		</svg>
	);
};
